  <h2 mat-dialog-title>
    <span *ngIf="data.moduleName!='Portal'" class="groupIcon"><mat-icon>touch_app</mat-icon></span>
    <span *ngIf="data.moduleName=='Portal'" class="groupIconPortal"><mat-icon>touch_app</mat-icon></span>
    <p *ngIf="data && !data.customInfo">Add Custom Info </p>
    <p *ngIf="data && data.customInfo && data.customInfo.customNoteID>0">Update Custom Info </p>        
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
    
  </h2>

<mat-dialog-content>
  <form [formGroup]="myCustomInfoForm" class="fix-mat-form-field">    
    <div class="divideCol">
        <div class="dflex">
          <mat-form-field>
            <mat-label>Custom Info Type</mat-label>
            <mat-select  formControlName="customNoteType" matInput (selectionChange)="DropDownCustomInfoType($event)">
              <mat-option *ngFor="let rel of CustomInfoType" [value]="rel.customInfoTypeID">
                {{rel.customInfoName}}
              </mat-option>
           </mat-select>            
          </mat-form-field>  

          <button  *ngIf="data.moduleName!='Portal'" mat-icon-button color="primary"
           (click)="openDialogAddWithRef()" matTooltip="Add Custom Info Type"> 
           <mat-icon>add</mat-icon> 
          </button>

        </div>        

    </div>


    <div class="divideCol">
      <mat-form-field>
        <mat-label>Custom Description</mat-label>
        <mat-select formControlName="customNoteStatus" matInput>
          <mat-option *ngFor="let rel of statusList" [value]="rel.customNoteStatusID">
            {{rel.customNoteStatusName}}
          </mat-option>
       </mat-select>          
      </mat-form-field> 

      <div *ngIf="showStatusButton==true">     
      <button *ngIf="data.moduleName!='Portal'" mat-icon-button color="primary"
           (click)="openDialogAddStatusWithRef()" matTooltip="Add Custom Description"> 
           <mat-icon>add</mat-icon> 
          </button>
     </div>

     </div>

 
    
  

    <mat-form-field>
      <mat-label>Notes</mat-label>
      <textarea  matInput formControlName="customNote"
                cdkTextareaAutosize
                cdkAutosizeMinRows="8"
                cdkAutosizeMaxRows="8"></textarea>
    </mat-form-field>

  

  </form>
  </mat-dialog-content>
  
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button *ngIf="data && !data.customInfo" mat-flat-button class="calltoaction" [disabled]="myCustomInfoForm.invalid || !myCustomInfoForm.dirty" type="submit"
      (click)="AddCustomInfo(myCustomInfoForm.value)" color="primary">
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
      </mat-spinner></mat-icon>
      Save
    </button>  
    <button *ngIf="data && data.customInfo && data.customInfo.customNoteID>0" mat-flat-button class="calltoaction" [disabled]="myCustomInfoForm.invalid || !myCustomInfoForm.dirty" type="submit"
      (click)="SaveCustomInfoDetail(myCustomInfoForm.value)" color="primary">
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
      </mat-spinner></mat-icon>
      Update
    </button>   
  </mat-dialog-actions>



  

  




